import { gql } from "@apollo/client";

export const UPDATE_BRAND_FEATURE_STATUS = gql`
  mutation UpdateBrandFeatureStatus($params: BrandFeatureStatusInput!) {
    updateBrandFeatureStatus(params: $params) {
      brandFeatureId
      brandFeatureKey
      brandFeatureName
      brandFeatureDescription
      brandFeatureIsActive
      brandFeatureIsMainMenu
      brandFeatureMappingId
      brandFeatureMappingCreatedAt
      brandFeatureMappingCreatedBy
    }
  }
`;
